@if (progress$ | async; as progress) {
  <strong>{{ progress.subject }} ({{ progress.current }}/{{ progress.total }})</strong>
  <cm-indicator data-type="linear" [attr.data-percentage]="progress.progress" data-hide-label></cm-indicator>
} @else {
  <strong>Action in progress</strong>
  <cm-indicator data-type="linear" [attr.data-percentage]="0" data-hide-label></cm-indicator>
}

